import dayjs from 'dayjs/esm';

const locale = {
    name: 'so',
    weekdays: 'Axad_Isniin_Talaado_Arbaco_Khamiis_Jimco_Sabti'.split('_'),
    months: 'Jannaayo_Febraayo_Maarso_Abriil_Maajo_Juun_Luulyo_Agoosto_Sebteembar_Oktoobar_Nofeembar_Diseembar'.split('_'),
    weekStart: 6,
    weekdaysShort: 'Axd_Isn_Tal_Arb_Kha_Jim_Sab'.split('_'),
    monthsShort: 'Jan_Feb_Mar_Abr_May_Jun_Lul_Ago_Seb_Okt_Nof_Dis'.split('_'),
    weekdaysMin: 'Ax_Is_Ta_Ar_Kh_Ji_Sa'.split('_'),
    ordinal: (n) => n,
    formats: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'DD MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    relativeTime: {
        future: '%s gudahood',
        past: '%s ka hor',
        s: 'ilbiriqsiyo',
        m: 'daqiiqad',
        mm: '%d daqiiqadood',
        h: 'saacad',
        hh: '%d saacadood',
        d: 'maalin',
        dd: '%d maalmood',
        M: 'bil',
        MM: '%d bilood',
        y: 'sanad',
        yy: '%d sano'
    }
};

dayjs.locale(locale, null, true);

export default locale;
